import React, { useState, useEffect, useRef } from "react";
import { handleRegister } from "services/registrationService";
import RegistrationConfirmationForm from "./RegistrationConfirmationForm";

const UserSearch = ({ tournament, registrations, users }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const resultsRef = useRef(null);
  const registrationLimit = tournament.registrationLimit || tournament.RegistrationLimit;

  // ✅ Close results if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (resultsRef.current && !resultsRef.current.contains(event.target)) {
        setSearchResults([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ✅ Debounced Search
  useEffect(() => {
    if (searchTerm.length < 3) {
      setSearchResults([]);
      return;
    }

    const timeoutId = setTimeout(() => {
      const filteredResults = users.filter((user) =>
        user.name?.toLowerCase().includes(searchTerm.toLowerCase())
      );

      setSearchResults(filteredResults);
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [searchTerm, users]);

  // ✅ Confirm registration with optional partner
  const handleConfirm = async (finalName, partnerId, partnerName) => {
    await handleRegister(tournament, registrations, selectedUser, finalName, partnerId, partnerName);
    setSearchTerm("");
    setSearchResults([]);
    setSelectedUser(null);
  };

  return (
    <div className="mt-2 w-full relative" ref={resultsRef}>
      {/* 🔹 Search Input */}
      <input
        type="text"
        placeholder="Ajouter un participant..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="w-full px-4 py-2 rounded-lg bg-slate-800 border border-slate-700 text-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
        disabled={registrations.length >= registrationLimit}
      />

      {/* 🔹 Search Results */}
      {searchResults.length > 0 && (
        <div className="z-50 mt-2 bg-slate-800 p-4 rounded-lg shadow-xl w-full border border-slate-800">
          <h4 className="text-lg text-slate-50 mb-2">Résultats :</h4>
          <ul>
            {searchResults.map((user) => (
              <li
                key={user.id}
                className="cursor-pointer hover:bg-slate-800/50 p-2 rounded-md flex justify-between items-center text-slate-50"
                onClick={() => {
                  setSelectedUser(user);
                  setSearchResults([]);
                }}
              >
                {user.name}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* 🔹 Registration Form Modal */}
      {selectedUser && (
        <div className="mt-4 p-4 border rounded bg-slate-800">
          <h3 className="text-lg font-bold mb-2 text-slate-50">
            Inscrire {selectedUser.name}
          </h3>
          <RegistrationConfirmationForm
            tournament={tournament}
            user={selectedUser}
            users={users.filter((u) => u.id !== selectedUser.id)}
            onConfirm={handleConfirm}
            onCancel={() => setSelectedUser(null)}
          />
        </div>
      )}
    </div>
  );
};

export default UserSearch;
